import AthleteCells from './AthleteCells';
import AttemptCells from './AttemptCells';
import TotalCells from './TotalCells';
import { computeCallingOrder } from '../../../rules/callingOrder';
import {
  liftsSelector,
  eventsSelector,
  protocolsSelector,
  resultsSelector,
} from '../../../orm/selectors';
import ormActions from '../../../orm/actions';
import venueActions from '../../../venue/actions';
import { bickActions } from '../../../common';

import { Header, Icon, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import { findIndex, get, map, pick } from 'lodash';

import io from 'socket.io-client';

const ProtocolHeader = ({ meta }) => (
  <Table.Header>
    <Table.Row>
      <AthleteCells.Header1 />
      {meta.orm.lifts.map(lift => (
        <AttemptCells.Header1 key={lift.id} lift={lift} />
      ))}
      <Table.HeaderCell>Total</Table.HeaderCell>
    </Table.Row>
    <Table.Row>
      <AthleteCells.Header2 />
      {meta.orm.lifts.map(lift => (
        <AttemptCells.Header2 key={lift.id} lift={lift} />
      ))}
      <Table.HeaderCell>Total</Table.HeaderCell>
      {/*<Table.HeaderCell width={1}>Rank</Table.HeaderCell>*/}
    </Table.Row>
  </Table.Header>
);

const ProtocolRow = ({ row, actions, meta }) => (
  <Fragment>
    <Table.Row>
      <AthleteCells
        athlete={row.meta.athlete}
        callingOrder={row.callingOrder}
      />
      {meta.orm.lifts.map(lift => (
        <AttemptCells key={lift.id} row={row} lift={lift} actions={actions} />
      ))}
      <TotalCells row={row} />
    </Table.Row>
  </Fragment>
);

class Protocol extends React.Component {
  state = {
    socket: null,
  };

  componentDidMount() {
    const socket = io('http://10.10.10.234:3000');
    socket.on('connect', () => {
      console.log('Referee lights connected');
    });
    socket.on('lights:activate', this.onLightsActivate);
    this.setState({ socket });
  }

  componentWillUnmount() {
    const { socket } = this.state;
    if (!socket) return;
    socket.close();
  }

  declaration = (athlete, lift, attemptNumber, changeNumber, weight) => {
    const { actions } = this.props;

    const { declaration: declarationActions } = actions.orm;

    const primaryKey = {
      athlete: athlete.primaryKey,
      lift: lift.primaryKey,
      attemptNumber,
      changeNumber,
    };

    if (!weight) declarationActions.destroy(Object.values(primaryKey));
    else declarationActions.upsert({ ...primaryKey, weight });
  };

  decision = (athlete, lift, attemptNumber, weight, isGoodLift) => {
    const { actions } = this.props;

    const { attempt: attemptActions, decision: decisionActions } = actions.orm;
    const nextAttemptNumber = attemptNumber + 1;

    const primaryKey = {
      athlete: athlete.primaryKey,
      lift: lift.primaryKey,
      number: attemptNumber,
    };

    // FIXME: Move automatic increase logic to server.

    if (!weight) {
      attemptActions.destroy(Object.values(primaryKey));
      this.declaration(athlete, lift, nextAttemptNumber, 0, undefined);
      return;
    }

    // FIXME: Must be re-ordered to avoid jumping cursor.
    if (nextAttemptNumber <= lift.attemptCount) {
      const automaticWeight = weight + (isGoodLift ? 1 : 0);
      this.declaration(athlete, lift, nextAttemptNumber, 0, automaticWeight);
    }

    attemptActions.upsert({ ...primaryKey, weight });
    decisionActions.upsert({
      attempt: Object.values(primaryKey),
      origin: 'manual',
      isGoodLift,
    });
  };

  importDecision = isGoodLift => {
    const { lift, callingOrder = [] } = this.props;

    if (!callingOrder.length) return;
    const current = callingOrder[0];
    const declaration = current.lastDeclarationByLiftId[lift.id];
    this.decision(
      pick(current, 'primaryKey'),
      lift,
      declaration.attemptNumber,
      declaration.weight,
      isGoodLift,
    );
    /*
    const currentAthlete = find(
      protocol.athletes,
      pick(callingOrder[0], 'primaryKey'),
    );
    */
  };

  onLightsActivate = data => {
    const { actions } = this.props;
    console.log('ACTIVATE LIGHTS!', data);
    const goodLiftCount = data.filter($ => $ === 'good-lift').length;
    const noLiftCount = data.filter($ => $ === 'no-lift').length;

    actions.competition.refereeLights.show(data);
    if (goodLiftCount > noLiftCount) {
      this.importDecision(true);
    } else {
      this.importDecision(false);
    }
    setTimeout(() => {
      actions.competition.refereeLights.reset();
    }, 3000);
  };

  render() {
    const { orm, protocol, lift, callingOrder = [] } = this.props;

    const rowActions = pick(this, 'declaration', 'decision');

    const rowMeta = { lifts: orm.lifts };
    const rows = map(protocol.athletes, athlete => ({
      key: athlete.startNumber,
      callingOrder: findIndex(callingOrder, pick(athlete, 'primaryKey')),
      ...resultsSelector(athlete, rowMeta),
      meta: { athlete },
    }));

    const onGoodLift = () => this.importDecision(true);

    const onNoLift = () => this.importDecision(false);

    return (
      <section /*className="nosturi protocol section"*/>
        <Header as="h2">
          {protocol.title}
          {lift ? (
            <span>
              {' '}
              <Icon name="angle right" />
              {lift.title}
            </span>
          ) : (
            ''
          )}
        </Header>
        <div style={{ float: 'right' }}>
          <button disabled={!callingOrder.length} onClick={onGoodLift}>
            Good lift
          </button>
          <button disabled={!callingOrder.length} onClick={onNoLift}>
            No lift
          </button>
        </div>
        {process.env.NODE_ENV !== 'production' && (
          <p>Calling order: {map(callingOrder, 'startNumber').join(', ')}</p>
        )}
        <Table
          size="small"
          fixed
          singleLine
          unstackable
          compact="very"
          //className="nosturi protocol table"
        >
          <AthleteCells.ColGroup />
          {orm.lifts.map(lift => (
            <AttemptCells.ColGroup key={lift.id} lift={lift} />
          ))}
          <TotalCells.ColGroup />
          <ProtocolHeader meta={{ orm }} />
          <Table.Body>
            {rows.map(row => (
              <ProtocolRow
                key={row.key}
                row={row}
                actions={rowActions}
                meta={{ orm }}
              />
            ))}
          </Table.Body>
        </Table>
      </section>
    );
  }
}

Protocol.propTypes = {
  orm: PropTypes.object.isRequired,
  protocol: PropTypes.object.isRequired,
  lift: PropTypes.object.isRequired,
  callingOrder: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = () => {
  const callingOrderSelector = createSelector(
    ({ protocol }) => get(protocol, 'athletes', []),
    ({ lift }) => get(lift, 'id', -1),
    ({ event }) => get(event, 'mode', 'default'),
    (athletes, liftId, mode) => {
      if (!athletes.length || liftId === -1) return [];
      return computeCallingOrder(athletes, liftId, mode);
    },
  );

  return ({ orm }, ownProps) => {
    const events = eventsSelector(orm);

    const [currentEvent] = events;

    return {
      orm: {
        lifts: liftsSelector(orm),
        protocols: protocolsSelector(orm),
      },
      callingOrder: callingOrderSelector({
        ...pick(ownProps, 'protocol', 'lift'),
        event: currentEvent,
      }),
    };
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    orm: bickActions(
      ormActions,
      ['declaration', 'attempt', 'decision'],
      dispatch,
    ),
    competition: bickActions(
      venueActions.competition,
      ['refereeLights'],
      dispatch,
    ),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Protocol);



// WEBPACK FOOTER //
// ./src/terminals/Director/Protocol/Protocol.js